<template class="full-height">
  <div class="full-height">
    <saleer-create-or-update-dialog
      :visible.sync="dialogVisibleBySaleer"
      :initial-form-data.sync="formDataBySaleer"
      :auth-edit="authEdit"
      :agency-code="formDataBySaleer.agencyCode"
      :agency-list="agencyList"
      @save="handleDialogSaveBySaleer"
      @closed="handleDialogCloseBySaleer"
    />

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.search.name"
          placeholder="輸入旅行社代碼/業務員暱稱/業務員姓名"
          @keyup.enter.native="getList"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        type="warning"
        @click="handleCreateSaleer"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        ref="formDetailsTable"
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
        @sort-change="sortChange"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="手機號碼" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="業務員姓名" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="業務員暱稱" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.nickName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              :type="authEdit ? 'success' : 'info'"
              @click="handleEditSaleer(scope.row)"
              size="mini"
            >
              {{ authEdit ? '編輯' : '查看' }}
            </el-button>
            <el-button
              v-if="authEdit"
              type="danger"
              @click="handleDeleteSaleer(scope.row)"
              size="mini"
            >
              刪除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import checkPermission from '@/utils/permission' // 权限判断函数
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { deleteSaleer, getSaleerForPaged } from '@/api/agency'

import { getAgencyOptions } from '@/api/travel'
import SaleerCreateOrUpdateDialog from '@/components/Dialog/SaleerCreateOrUpdateDialog.vue'

export default {
  name: 'SaleerTable',
  components: { Pagination, SaleerCreateOrUpdateDialog },
  props: {
    agencyCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      authEdit: true,
      agencyList: [],
      formLabelWidth: '120px',
      dialogVisibleBySaleer: false,
      loading: false,
      formLoadingBySaleer: false,
      formDataBySaleer: {
        id: null,
        agencyCode: '',
        name: '',
        nickName: '',
        mobile: '',
        mail: '',
        lineID: '',
      },
      listQuery: {
        search: {
          name: '',
        },
        agencyCode: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      isAdmin: this.checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF']),
    }
  },
  watch: {
    async agencyCode(value) {
      if (value) {
        this.listQuery.agencyCode = value
        await this.getList()
      }
    },
    async loading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showDownloadLoading', true)
          await this.$store.dispatch('app/showDownloadLoadingText', '資料處理中，請稍後')
        } catch (error) {
          await this.$store.dispatch('app/showDownloadLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
  },
  async created() {
    this.listQuery.agencyCode = this.agencyCode
    await this.getAgencyOptions()
    await this.getList()
  },
  methods: {
    checkPermission,
    async handleCreateSaleer() {
      this.formDataBySaleer = {
        agencyCode: JSON.parse(JSON.stringify(this.agencyCode)),
      }
      this.dialogVisibleBySaleer = true
    },
    handleEditSaleer(d) {
      this.formDataBySaleer = JSON.parse(JSON.stringify(d))
      this.dialogVisibleBySaleer = true
    },
    async handleDeleteSaleer(d) {
      this.loading = true
      if (confirm(`確定要刪除${d.name}業務員嗎?`)) {
        await deleteSaleer(d)
          .then(res => {
            this.refresh()
            this.$message({
              message: '刪除成功',
              type: 'success',
            })
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async handleDialogSaveBySaleer() {
      this.refresh()
      this.dialogVisibleBySaleer = false
      this.formDataBySaleer = {}
    },
    handleDialogCloseBySaleer() {
      this.formDataBySaleer = {}
      this.dialogVisibleBySaleer = false
    },
    async refresh() {
      this.initListyQuery()
      await this.getList()
    },
    async sortChange(data) {
      const { prop, order } = data

      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }

      this.listQuery.page = 1
      await this.getList()
    },
    tableRowClassName({ row, rowIndex }) {
      return 'success-row'
    },
    initListyQuery() {
      this.listQuery = {
        search: {
          name: '',
        },
        agencyCode: this.agencyCode,
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
    },
    async getAgencyOptions() {
      this.listLoading = true
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
        this.listLoading = false
      })
    },
    async getList() {
      const vm = this
      vm.loading = true
      await getSaleerForPaged(this.listQuery).then(response => {
        this.loading = false
        this.list = response.data.data
        this.total = response.data.total
      })
    },
  },
}
</script>
<style>
.el-dialog__body {
  padding: 15px;
}
</style>

<style scoped>
/deep/.leader-data .el-form .is-disabled * {
  color: blue !important;
}

/deep/.el-upload .el-button {
  display: none !important;
}

/deep/.el-upload-list__item-status-label {
  display: none !important;
}

/deep/.el-icon-close {
  display: none !important;
}
</style>
<style lang="scss" scoped>
.full-height {
  position: relative;
  height: 100%;
}
.el-dialog__body {
  padding-top: 15px !important;
}
</style>
